export enum PatientSelectorType {
  Program = 'Program',
  HealthManager = 'HealthManager',
}

export default {};
